/**
 * 画面风格选项：按分类标签页组织的风格卡片清单。
 * value 为稳定编码，与后端 cg_project.art_style 存储编码、ProjectArtStyleEnum 一一对应；
 * 缩略图取设计提供的 16 张风格模板示意图（见 assetManifest.artStyles）。
 */
/** 画面风格分类标签项，value 为分类编码，'all' 表示不过滤的汇总标签页。 */
export const PROJECT_ART_STYLE_CATEGORIES = [
    { value: 'all', label: '全部' },
    { value: '2d', label: '2D动画' },
    { value: '3d', label: '3D动画' },
    { value: 'special', label: '特殊风格' },
    { value: 'live-action', label: '真人影游' },
];
/** 画面风格清单（与设计提供的 16 张风格模板一一对应），仅通过 filterArtStylesByCategory 对外暴露。 */
const PROJECT_ART_STYLE_OPTIONS = [
    { value: 'shinkai', label: '新海诚风格', category: '2d' },
    { value: '2d-comic', label: '2D国漫画风', category: '2d' },
    { value: 'retro-90s', label: '90年代复古港风', category: '2d' },
    { value: '2d-pixel-illustration', label: '插画风', category: '2d' },
    { value: '2d-pixel', label: '2D像素风', category: '2d' },
    { value: 'ghibli', label: '吉卜力画风', category: '2d' },
    { value: 'american-comic', label: '美式漫画风格', category: '2d' },
    { value: '2d-anime', label: '2D赛璐璐', category: '2d' },
    { value: 'ink-wash', label: '国风线描色彩', category: '2d' },
    { value: '3d-ancient', label: '3D古风国漫', category: '3d' },
    { value: '3d-anime', label: '皮克斯风格', category: '3d' },
    { value: '3d-american-anime', label: '3D艺美国风', category: '3d' },
    { value: 'stop-motion', label: '折纸动画风', category: 'special' },
    { value: 'arcane', label: 'Arcane风格', category: 'special' },
    { value: 'oil-painting', label: '厚涂油画风格', category: 'special' },
    { value: 'live-action-original', label: '真人质感', category: 'live-action' },
];
/** 风格清单过滤：分类为 'all' 或缺失时返回全量清单。 */
export function filterArtStylesByCategory(category) {
    if (category === 'all')
        return PROJECT_ART_STYLE_OPTIONS;
    return PROJECT_ART_STYLE_OPTIONS.filter((option) => option.category === category);
}
